import { postRequest } from "../httpMethods";

export const postBoard = (payload) => postRequest("v1/sv/masters/board", payload);
export const postMedium = (payload) => postRequest("v1/sv/masters/medium", payload);
export const postGrade = (payload) => postRequest("v1/sv/masters/grade", payload);
export const postSection = (payload) => postRequest("v1/section", payload);
